export default {
    index: [
        {
            path: '/404',
            component: resolve => require(['./404.vue'], resolve),
        }, {
            path: '/403',
            component: resolve => require(['./403.vue'], resolve),
        }, {
            path: '/index',
            component: resolve => require(['./index.vue'], resolve),
        }, {
            path: '/dika',
            component: resolve => require(['./dika.vue'], resolve),
        },

    ]
}



// WEBPACK FOOTER //
// ./src/view/common/_router.js